const MAPPER_ONLY_PROPAGATE_MAPPED_KEYS = {
    description: 'The flag modifies the behavior of the Mapper component, making it stop propagating the entire `data` object down, only passing the mapped keys.',
    key: 'MAPPER_ONLY_PROPAGATE_MAPPED_KEYS',
    value: false,
};
const PROXY_WRAPPED_APIS = {
    description: 'The flag modifies the behavior of API instances, wrapping them in a revocable proxy, allowing the framework to properly discard them when necessary.',
    key: 'PROXY_WRAPPED_APIS',
    value: true,
};
const SPREADER_CONSIDER_VALUE_INSTEAD_OF_DATA = {
    description: 'The flag modifies the behavior of the spread component, making it use the `value` property as a source when selecting entries to be spreaded.',
    key: 'SPREADER_CONSIDER_VALUE_INSTEAD_OF_DATA',
    value: false,
};
const ENABLE_TREE_TABLE = {
    description: 'The flag modifies the behavior of the Table component, allowing it to use the `isTree` property to render the data as a tree.',
    key: 'ENABLE_TREE_TABLE',
    value: false,
};
export { ENABLE_TREE_TABLE, MAPPER_ONLY_PROPAGATE_MAPPED_KEYS, PROXY_WRAPPED_APIS, SPREADER_CONSIDER_VALUE_INSTEAD_OF_DATA, };
//# sourceMappingURL=experimental-flags.js.map